/* eslint-disable no-underscore-dangle,@typescript-eslint/no-unused-vars,no-useless-escape,radix */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';
import { DESIGNER_SETTINGS } from '../../../../../app/constants/designer_settings';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerNote', [
    '$timeout',
    '$rootScope',
    'DesignerBase',
    function ($timeout, $rootScope, DesignerBase) {
      function DesignerNote(data, _package) {
        this.package = _package;
        this.designer = _package.designer;
        this.element = null;
        this.id = null;
        this.description = '';
        this.selected = false;
        this.draggable = false;
        this.initiated = false;

        this.width = DESIGNER_SETTINGS.NOTE_WIDTH;
        this.height = DESIGNER_SETTINGS.NOTE_HEIGHT;

        this.$body = null;
        this.$remove = null;
        this.$duplicate = null;
        this.$textarea = null;

        this.COMPONENT_PREFIX = 'note-';

        this.setData(this.fixData(data));
      }

      DesignerNote.prototype = new DesignerBase();

      DesignerNote.prototype.setElement = function (element) {
        this.element = element;
        this.$body = element.find('.designer-note-body');
        this.$remove = element.find('.designer-note-remove');
        this.$duplicate = element.find('.designer-note-duplicate');
        this.$textarea = element.find('textarea');
        this.$foreignObject = element.find('foreignObject');
        this.$text = element.find('p');

        const regex = /<br\s*[\/]?>/gi;
        this.$textarea.val(this.description ? this.description.replace(regex, '\n') : '');
        this.$textarea.hide();
        this.initEvents();
        this.setPosition();
        this.initiated = true;
        this.bind();
      };

      DesignerNote.prototype.getId = function () {
        return this.COMPONENT_PREFIX + this.uid();
      };

      DesignerNote.prototype.setData = function (data) {
        if (data) {
          this.id = data.id;
          this.description = data.description;
        } else {
          this.id = this.COMPONENT_PREFIX + this.uid();
        }

        if (data && data.xy) {
          this.x = this.snapToGrid(parseInt(data.xy[0]));
          this.y = this.snapToGrid(parseInt(data.xy[1]));
        } else {
          this.x = this.snapToGrid((this.designer ? this.designer.width : this.package.width) / 2);
          this.y = this.cell * 3;
        }
      };

      DesignerNote.prototype.getData = function () {
        const data = {
          id: this.id,
          name: this.name,
          alias: this.name,
          xy: [this.x, this.y],
          description: this.description ? this.description.replace(/\n/g, '<br />') : '',
        };

        return data;
      };

      DesignerNote.prototype.bind = function () {
        if (!this.initiated) return;

        if (this.selected) {
          this.element[0].classList.add('selected');
        } else {
          this.element[0].classList.remove('selected');
        }

        if (this.draggable) {
          this.element[0].classList.add('draggable');
        } else {
          this.element[0].classList.remove('draggable');
        }

        this.$text.html(_.escape(this.description).replaceAll('&lt;br /&gt;', '<br />'));
        this.setHeigth();
      };

      DesignerNote.prototype.setOffset = function (offset) {
        this.element.attr('transform', `translate(${this.x - offset.x}, ${this.y - offset.y})`);
      };

      DesignerNote.prototype.setHeigth = function () {
        const height = this.$text.height();
        this.height = height + 65;
        this.$body.attr('height', this.height);
        this.$textarea.height(height);
        this.$foreignObject.attr('height', height);
        this.$foreignObject.attr('height', height);
      };

      DesignerNote.prototype.setDescription = function (description) {
        if (this.description !== description) {
          this.description = description;
          this.designer.history.save('Note description changed');
          this.package.update();
        }
      };

      DesignerNote.prototype.initEvents = function () {
        const _this = this;

        this.componentSelectedDrag = $rootScope.$on(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG, function (event, offset) {
          if (_this.selected && !_this.draggable) {
            _this.setOffset(offset);
          }
        });

        this.componentSelectedDragStop = $rootScope.$on(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG_STOP, function (
          event,
          offset,
        ) {
          if (_this.selected && !_this.draggable) {
            _this.setPosition({
              x: _this.x - offset.x,
              y: _this.y - offset.y,
            });
            _this.snapComponentToGrid();
          }
        });

        const getPosition = function (ui) {
          const x = Math.round(ui.position.left - 50 + _this.designer.scrollLeft);
          let y = Math.round(ui.position.top + _this.designer.scrollTop);

          const $topHeader = $('.page-top-header');
          if ($topHeader.length) {
            y -= $topHeader.height();
          }

          const $herokuBoomerang = $('#heroku-boomerang');
          if ($herokuBoomerang.length) {
            y -= $herokuBoomerang.height();
          }

          return { x, y };
        };
        let startPosition;
        this.element.draggable({
          start(event, ui) {
            _this.setDraggable(true);
            startPosition = getPosition(ui);
          },
          stop(event, ui) {
            const position = getPosition(ui);
            _this.setPosition(position);
            _this.snapComponentToGrid();
            if (_this.selected) {
              $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG_STOP, {
                x: startPosition.x - position.x,
                y: startPosition.y - position.y,
              });
            }
            _this.setDraggable(false);
            _this.package.setSize();
            _this.package.update();
            _this.designer.history.save('Note position change');
          },
          drag(event, ui) {
            const position = getPosition(ui);
            _this.setPosition(position);
            if (_this.selected) {
              $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_SELECTED_DRAG, {
                x: startPosition.x - position.x,
                y: startPosition.y - position.y,
              });
            }
          },
        });

        this.$body.on('click', function () {
          $rootScope.$broadcast(DESIGNER_EVENTS.NOTE_EDIT, _this);
        });

        this.$remove.on('click', function () {
          _this.package.removeNote(_this);
        });

        this.$duplicate.on('click', function () {
          _this.package.addNote(_this.clone());
        });

        this.element.on('mouseover', function () {
          _this.moveToLast();
        });

        $timeout(function () {
          _this.$body.css({
            fill: `url(${_this.absUrl()}#note-bg)`,
          });
        }, 100);
      };

      DesignerNote.prototype.setPosition = function (position) {
        if (position) {
          this.x = position.x;
          this.y = position.y;
        }

        if (!this.element) return;

        this.element.attr('transform', `translate(${this.x}, ${this.y})`);

        if (this.designer.firefox) {
          this.element.attr('style', `left:${this.x}px;top:${this.y}px;`);
        }
      };

      DesignerNote.prototype.destroy = function () {
        this.componentSelectedDrag();
        this.componentSelectedDragStop();
      };

      DesignerNote.prototype.setSelection = function (selected) {
        this.selected = selected;
        this.bind();
      };

      DesignerNote.prototype.setDraggable = function (draggable) {
        this.draggable = draggable;
        this.bind();
      };

      DesignerNote.prototype.snapComponentToGrid = function () {
        const position = {
          x: this.snapToGrid(this.x),
          y: this.snapToGrid(this.y),
        };
        this.package.checkComponentPosition(position);
        this.setPosition(position);
      };

      DesignerNote.prototype.clone = function () {
        const cloneData = this.getData();
        cloneData.xy[0] += this.width + this.cell;
        cloneData.id = this.COMPONENT_PREFIX + this.uid();
        return new DesignerNote(cloneData, this.package);
      };

      return DesignerNote;
    },
  ]);
})(window.angular);
